/**
 * Auto redirection from dashboard to data.kemendikbud.go.id
 */
export const FLAG_KEY_DAVI_1163 = 'DAVI-1163'

/**
 * Data Induk PTK
 */
export const FLAG_KEY_DAVI_1128 = 'DAVI-1128'

/**
 * Rapor Publik
 */
export const FLAG_KEY_RAPOR_PUBLIK = 'RP'

export const isContainsWhitelist = (
  cookieVal: string[],
  flagKey: string
): boolean => {
  if (Array.isArray(cookieVal)) {
    return cookieVal.includes(flagKey)
  }

  return false
}
